export const applicationStore = {
    isMediaDevicesEnabled: true,
    requiresPermissionRequest: false,
    modalOpeningCount: 0,
    language: '',
    isLightRegistration: false,
    returnTo: '',
};
